module.exports = __webpack_public_path__ + "static/media/rosette-section-2.d29ae863.png";